import { useState, useEffect } from 'react'

const isPlainObject = value =>
  value != null && typeof value === 'object' && !Array.isArray(value)

/**
 * useState que persiste su valor en sessionStorage. Sobrevive a una recarga de
 * página (modal/filtros perdidos por HMR en dev o descarte de pestaña en prod)
 * pero se limpia al cerrar la pestaña.
 *
 * Para estados objeto, el valor almacenado se mergea sobre `initialValue` al
 * leer, de modo que un esquema viejo persistido no rompa el consumidor.
 */
export const usePersistedState = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(key)
      if (raw == null) return initialValue
      const stored = JSON.parse(raw)
      return isPlainObject(initialValue) && isPlainObject(stored)
        ? { ...initialValue, ...stored }
        : stored
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value))
    } catch {
      /* cuota o valor no serializable: se ignora la persistencia */
    }
  }, [key, value])

  return [value, setValue]
}

export default usePersistedState
